window.matomoReady = new Promise(resolve => {
	let _paq = (window._paq = window._paq || []);
	_paq.push(['enableLinkTracking']);

	let baseURL = '';
	let siteId = '';
	let hostname = window.location.hostname;
	switch (hostname) {
		case 'localhost':
			return; // Matomo est désactivé en mode développement.
		case 'dev-ecarpa.mycarpa.org':
			baseURL = '//dev-stats.mycarpa.org/';
			siteId = '8';
			break;
		case 'int-ecarpa.mycarpa.org':
			baseURL = '//int-stats.mycarpa.org/';
			siteId = '9';
			break;
		case 'rec-ecarpa.mycarpa.org':
			baseURL = '//rec-stats.mycarpa.org/';
			siteId = '10';
			break;
		case 'form-ecarpa.mycarpa.org':
			baseURL = '//form-stats.mycarpa.org/';
			siteId = '11';
			break;
		case 'preprod-ecarpa.mycarpa.org':
			baseURL = '//preprod-stats.mycarpa.org/';
			siteId = '12';
			break;
		case 'ecarpa.mycarpa.org':
			baseURL = '//stats.mycarpa.org/';
			siteId = '13';
			break;
		default:
			baseURL = 'https://dev-stats.mycarpa.org/';
			siteId = '8';
	}

	_paq.push(['setTrackerUrl', baseURL + 'matomo.php']);
	_paq.push(['setSiteId', siteId]);

	let g = document.createElement('script');
	g.async = true;
	g.src = baseURL + 'matomo.js';

	g.onload = function () {
		console.log('Matomo script loaded');
		window._matomoLoaded = true;
		resolve();
	};

	document.head.appendChild(g);
});
